import request from '@/utils/request'

export function getMe() {
  return request({
    url: '/users/me',
    method: 'get'
  })
}

export function fetchUsers(params) {
  return request({
    url: '/users',
    method: 'get',
    params
  })
}

export function fetchUserScopeOptions() {
  return request({
    url: '/users/scope-options',
    method: 'get'
  })
}

export function resolveDetonatorFactory(code) {
  return request({
    url: `/users/resolve-detonator-factory/${code}`,
    method: 'get'
  })
}

export function resolveBlastCompany(code) {
  return request({
    url: `/users/resolve-blast-company/${code}`,
    method: 'get'
  })
}

export function createUser(data) {
  return request({
    url: '/users',
    method: 'post',
    data
  })
}

export function updateUser(id, data) {
  return request({
    url: `/users/${id}`,
    method: 'put',
    data
  })
}

export function resetUserPassword(id) {
  return request({
    url: `/users/${id}/reset-password`,
    method: 'post'
  })
}

export function changeMyPassword(data) {
  return request({
    url: '/users/me/password',
    method: 'put',
    data
  })
}

export function deleteUser(id) {
  return request({
    url: `/users/${id}`,
    method: 'delete'
  })
}

export function fetchUserOperationLogs(id, params) {
  return request({
    url: `/users/${id}/operation-logs`,
    method: 'get',
    params
  })
}
